module.exports = __webpack_public_path__ + "img/proList2_27_08.acc01fcb.jpg";